module.exports = __webpack_public_path__ + "static/media/red_velvet_for_oxygen.4026dc36.jpeg";